// extracted by mini-css-extract-plugin
export default {"input":"mca-z","button":"nca-z","selected":"oca-z","unavailable":"pca-z","oos":"qca-z","paperCutDisabledOverlay":"rca-z","image":"sca-z"};